module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("ZoneAlias", "Change alias for this zone") ))==null?'':__t)+
' <button class="ir info-icon" data-button="info-show"></button></legend><dl><dd class="info hidden" data-info="alwaysOn-info"><div>'+
((__t=( i18n.tc("ZoneAlias", "Choose an alias for what the zone controls and an alias for where the temperature in this zone is measured, max 24 characters.")))==null?'':__t)+
'</div></dd></dl><div><label for="zone-alias-input">'+
((__t=( i18n.tc("ZoneAlias", "Zone name:") ))==null?'':__t)+
'</label> <input maxlength="24" class="disable" type="text" id="zone-alias-input" data-input="zone-alias" value="'+
((__t=( zoneAlias ))==null?'':__t)+
'"></div><div><label for="temperature-alias-input">'+
((__t=( i18n.tc("ZoneAlias", "Temperature Alias:") ))==null?'':__t)+
'</label> <input class="disable" type="text" id="temperature-alias-input" data-input="temperature-alias" value="'+
((__t=( temperatureAlias ))==null?'':__t)+
'"></div></fieldset><fieldset class="button-wrap"><button data-click="alias-cancel">'+
((__t=( i18n.tc("ZoneAlias", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="alias-submit">'+
((__t=( i18n.tc("ZoneAlias", "Save") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
